import React from 'react';
import OptimizedImage from 'components/shared/OptimizedImage';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMFeatureStaffView extends React.Component {
  
  constructor(props) {
    super(props);
  }
  
  componentDidMount() {
  }
  
  render() {
    let rows = [];
    const featureImageWidth = 308;
    const featureImageHeight = 172;

    this.props.staffFeatures.forEach((staffFeature, index) => {
      const feature = staffFeature.item;
      const featureImageUrl = SMFormatHelper.imageURLWithTransform(feature.image, {width: featureImageWidth, height: featureImageHeight});

      rows.push(
        <a key={feature.id} href={Routes.feature_path(feature.uid)}>
          <div className="lpsearch-sidebar__space clearfix">
            <OptimizedImage
              src={featureImageUrl}
              alt={feature.title}
              width={featureImageWidth}
              height={featureImageHeight}
              className="lpsearch-sidebar__matome-img"
            />
            <h3 className="lpsearch-sidebar__matome-title">{feature.title}</h3>
          </div>
        </a>
      );
    });
    return(
      <div className="site-sidebar">
        <h2 className="site-sidebar__headline">{I18n.t("service.label_000013")}</h2>
        {rows}
        <div className="lpsearch-sidebar__space-more">
          <a href={Routes.features_path()} className="a__underline">{I18n.t("service.label_000014")}</a>
        </div>
      </div>
    );
  }
  
}
export default SMFeatureStaffView;



// WEBPACK FOOTER //
// ./app/javascript/components/features/SMFeatureStaffView.jsx